import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SmartChargeOverrideHook } from '../hooks/useSmartChargeOverride'
import ChargeStateDisplay from './ChargeStateDisplay'
import ChargingState from './ChargingState'

interface ChargingProps {
	smartOverride: SmartChargeOverrideHook
	vehicle: ENodeVehicle | null | undefined
	isError: boolean
}
const Charging = ({ smartOverride, vehicle, isError }: ChargingProps) => {
	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'electricCarDetail' })

	return (
		<div className='flex flex-col justify-center items-center text-[#52AE32] dark:text-[#3CB49F] gap-3'>
			<ChargingState vehicle={vehicle} smartOverride={smartOverride} isError={isError} />
			<ChargeStateDisplay powerDeliveryState={vehicle?.chargeState?.powerDeliveryState} />

			{vehicle?.chargeState?.isCharging && !vehicle?.smartChargingPolicy.isEnabled && (
				<div className='mt-4 p-5 rounded-xl bg-white dark:bg-brand-secondary-200-dark border-brand-primary-100-light dark:border-brand-primary-100-dark w-full max-w-sm'>
					<div className='flex flex-col gap-4 text-sm'>
						<div className='flex items-center justify-between py-2'>
							<span className='font-medium text-gray-700 dark:text-gray-300'>
								{t('estimatedChargeTime')}:
							</span>
							<span className='font-semibold ml-3'>
								{(() => {
									const totalMinutes = vehicle?.chargeState?.chargeTimeRemaining ?? 0
									const hours = Math.floor(totalMinutes / 60)
									const minutes = totalMinutes % 60

									if (hours > 0) {
										return `${hours} ${t('hours')} ${minutes} ${t('minutes')}`
									} else {
										return `${minutes} ${t('minutes')}`
									}
								})()}
							</span>
						</div>

						{vehicle?.chargeState?.chargeTimeRemaining &&
							vehicle?.chargeState?.chargeTimeRemaining > 0 && (
								<div className='flex items-center justify-between py-2'>
									<span className='font-medium text-gray-700 dark:text-gray-300'>
										{t('estimatedFinishTime')}:
									</span>
									<span className='font-semibold ml-3'>
										{dayjs()
											.add(vehicle?.chargeState?.chargeTimeRemaining ?? 0, 'minute')
											.tz('Europe/Helsinki')
											.locale('fi')
											.format('HH:mm')}
									</span>
								</div>
							)}
					</div>
				</div>
			)}
		</div>
	)
}

export default Charging
